import { composeIO } from 'react-compose-io'
import { listaTitulosParceirosIO } from './ListaTitulosParceiros.IO'
import { ListaTitulosParceirosView } from './ListaTitulosParceiros.View'

export const ListaTitulosParceiros = composeIO(ListaTitulosParceirosView, listaTitulosParceirosIO)
